// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoyaltyContactFormTextArea-module-textareaWrapper-1z8h\\+{width:100%;gap:0;margin-block-end:0}.LoyaltyContactFormTextArea-module-textareaWrapper-1z8h\\+>div:first-child{padding-inline:0;padding-block:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textareaWrapper": "LoyaltyContactFormTextArea-module-textareaWrapper-1z8h+"
};
export default ___CSS_LOADER_EXPORT___;
